module.exports = __webpack_public_path__ + "img/legend_e.20cfa89e.png";